import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT, PIMSEnvironment } from "environments";
import { Observable } from 'rxjs';
import { Medication } from '../../../../../../../types/medications';

@Injectable({
  providedIn: 'root',
})
export class MedicationsByServiceAPI {
	private http = inject(HttpClient);

	private env = inject<PIMSEnvironment>(ENVIRONMENT)

  getMedications(service_code: string): Observable<Medication[]> {
    return this.http.get<Medication[]>(`${this.env.constants.CMS_API_URL}/admin/medications/all/${service_code}`);
  }
}
